import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  height: "24px",
  width: "24px",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 35.919 24.506",
  style: {"fill":"currentColor"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      id: "download-cloud",
      transform: "translate(-1.435 -11.23)"
    }, [
      _createElementVNode("path", {
        id: "layer2",
        d: "M27.407,32.687h1.724a7.472,7.472,0,1,0,0-14.945h-.287a9.772,9.772,0,0,0-18.566,2.529A6.323,6.323,0,1,0,8.439,32.687h2.874",
        transform: "translate(0 0)",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-miterlimit": "10",
        "stroke-width": "1.5"
      }),
      _createElementVNode("path", {
        id: "layer1",
        d: "M28.6,30V42.646m-4.6-4.6,4.6,4.6,4.6-4.6",
        transform: "translate(-9.239 -7.66)",
        fill: "none",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-miterlimit": "10",
        "stroke-width": "1.5"
      })
    ], -1)
  ])))
}